import React from "react";
import PropTypes from "prop-types";


const WarningAlready = ({ conflict, correctUserToAcceptRequest, conflictShiftTimes }) => (
  conflict && correctUserToAcceptRequest ? (
    <span className="pink-text">
      <br />
      Warning: You are already scheduled to work from {conflictShiftTimes}
    </span>
  ) : null
);

const WarningMaxWeeklyHours = ({ activeRequestOverMaxWeeklyHours, correctUserToAcceptRequest, maxWeeklyHours }) => (
  activeRequestOverMaxWeeklyHours && correctUserToAcceptRequest ? (
    <span className="pink-text">
      <br />
      Warning: {maxWeeklyHours} max weekly hours exceeded
    </span>
  ) : null
);

const WarningMaxDailyHours = ({ activeRequestOverMaxDailyHours, correctUserToAcceptRequest, maxDailyHours }) => (
  activeRequestOverMaxDailyHours && correctUserToAcceptRequest ? (
    <span className="pink-text">
      <br />
      Warning: {maxDailyHours} max daily hours exceeded
    </span>
  ) : null
);

const Warnings = (
  { show, startOfWeek, endOfWeek, myHoursThisWeek, maxWeeklyHours, maxDailyHours,
    activeRequestOverMaxWeeklyHours, activeRequestOverMaxDailyHours, conflict, correctUserToAcceptRequest, conflictShiftTimes }
) => (
  show ? (
    <p className="grey-text">
      My hours the week of&nbsp;
      {[startOfWeek.format("MMM Do"), endOfWeek.format("MMM Do")].join(" - ")}:&nbsp;
      <br className="visible-xs" />

      {myHoursThisWeek} hours
      <WarningAlready
        conflict={conflict}
        correctUserToAcceptRequest={correctUserToAcceptRequest}
        conflictShiftTimes={conflictShiftTimes}
      />

      <WarningMaxWeeklyHours
        activeRequestOverMaxWeeklyHours={activeRequestOverMaxWeeklyHours}
        correctUserToAcceptRequest={correctUserToAcceptRequest}
        maxWeeklyHours={maxWeeklyHours}
      />

      <WarningMaxDailyHours
        activeRequestOverMaxDailyHours={activeRequestOverMaxDailyHours}
        correctUserToAcceptRequest={correctUserToAcceptRequest}
        maxDailyHours={maxDailyHours}
      />
    </p>
  ) : null
);

WarningAlready.propTypes = {
  conflict:                   PropTypes.bool,
  correctUserToAcceptRequest: PropTypes.bool,
  conflictShiftTimes:         PropTypes.string
};

WarningMaxWeeklyHours.propTypes = {
  activeRequestOverMaxWeeklyHours:  PropTypes.bool,
  correctUserToAcceptRequest:       PropTypes.bool,
  maxWeeklyHours:                   PropTypes.number,
};

Warnings.propTypes = {
  show:                             PropTypes.bool,
  startOfWeek:                      PropTypes.object,
  endOfWeek:                        PropTypes.object,
  myHoursThisWeek:                  PropTypes.number,
  maxWeeklyHours:                   PropTypes.number,
  conflict:                         PropTypes.bool,
  correctUserToAcceptRequest:       PropTypes.bool,
  activeRequestOverMaxWeeklyHours:  PropTypes.bool,
  conflictShiftTimes:               PropTypes.string
};

export default Warnings;
